import * as React from 'react';

import PreviewPage from '../../../containers/Editor/PreviewPagesSpread/PreviewPage';
import { Wrapper } from './styles';

interface PreviewPagesSpreadProps {
	spread: number[];
	zoom: number;
}

const PreviewPagesSpread = ({ spread, zoom }: PreviewPagesSpreadProps) => {
	const pageContainer = React.useRef<HTMLDivElement>(null);

	const handleLoad = () => {
		if (pageContainer.current) {
			pageContainer.current.scrollIntoView();
		}
	};

	return (
		<Wrapper
			ref={pageContainer}
			zoom={zoom}
		>
			{spread.map(page => (
				<PreviewPage
					key={page}
					page={page}
					onLoad={handleLoad}
				/>
			))}
		</Wrapper>
	);
};

export default PreviewPagesSpread;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PreviewPagesSpread/index.tsx